import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

const ConfirmDialog = ({ isOpen, toggle, title, message, onConfirm, loading }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>{title}</ModalHeader>
      <ModalBody>{message}</ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          No
        </Button>
        <Button color="danger" onClick={onConfirm} disabled={loading}>
          {loading ? "Deleting..." : "Yes"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ConfirmDialog;
